import _ from 'lodash';

const LoginButton = () => {
  const pathArray = window.location.pathname.split('/');
  const returnToPath = _.get(pathArray, '[1]', '');
  let signInPath = '/';
  const returnToParam = window.location.pathname + window.location.search;
  if (returnToPath) signInPath += `?return_to=${encodeURIComponent(returnToParam)}`;
  return (
      <button
        type="button"
        className="btn btn-primary login-btn"
        onClick={() => window.openLoginModal()}
      >
      <span>Signup / Login</span>
      </button>
  );
};

export default LoginButton;
